import Checkbox from 'components/Checkbox/Checkbox';
import React from 'react';
import './familyLinkRadio.scss';

type FamilyLinkRadioProps = {
  setIsFamilyLinked: Function;
  isFamilyLinked: boolean;
  isFirmAdmin: boolean;
};

const FamilyLinkRadio = ({
  setIsFamilyLinked,
  isFamilyLinked,
  isFirmAdmin
}: FamilyLinkRadioProps) => {
  return (
    <>
      <div style={{ marginTop: '1.5rem' }}>
        <span style={{ fontWeight: 'bold' }}>Family linking: </span>
      </div>
      <div className="radioButtonContainer">
        <Checkbox
          onClick={() => setIsFamilyLinked(true)}
          label={'Yes'}
          isChecked={!!isFamilyLinked}
          disabled={!isFirmAdmin}
        />
        <Checkbox
          onClick={() => setIsFamilyLinked(false)}
          label={'No'}
          isChecked={!isFamilyLinked}
          disabled={!isFirmAdmin}
        />
      </div>
    </>
  );
};

export default FamilyLinkRadio;
